import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import { Table, Loader, Grid, Button, Divider } from "semantic-ui-react";
import Field from "../misc/Field";
import { setAsyncRouteLeaveHook } from "../../utils/helpers";

class SingleUserEdit extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      confirmExit: false,
      nextLocation: "",
      passwordVisible: false,
      initialPassword: ""
    };
    this.getUserData = this.getUserData.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    setAsyncRouteLeaveHook(
      this.props.router,
      this.props.route,
      this.routerWillLeave.bind(this)
    );
    this.getUserData();
  }

  routerWillLeave(url) {
    let modified = this.props.modified;
    let showLeaveConfirmation = this.props.showLeaveConfirmation;
    return new Promise(resolve => {
      if (!modified) {
        // No unsaved changes -- leave
        resolve(true);
      } else {
        // Unsaved changes -- ask for confirmation
        showLeaveConfirmation(url);

        resolve(false);
      }
    });
  }

  showLeaveConfirmation(nextLocation) {
    this.setState({
      confirmExit: true,
      nextLocation: nextLocation
    });
  }

  getUserData() {
    let self = this;

    Flagship.get(
      "user/" + this.props.routeParams.splat,
      {},
      function(response) {
        if (response.data.success === true) {
          response.data.user.password = self.state.initialPassword;

          self.setState({
            userData: response.data.user
          });
        }
      },
      function(err) {
        Flagship.error(
          "Error getting user data: " + err,
          self.props.routeParams.splat,
          self.props.userId
        );
      }
    );
  }

  onChange(e, value, field) {
    let userData = Object.assign({}, this.state.userData);

    userData[field] = value;

    this.setState({
      userData
    });
  }

  saveUser() {
    let self = this;

    Flagship.post(
      "save-user/" + this.props.routeParams.splat,
      { userData: self.state.userData },
      function(response) {
        if (response.data.success === true) {
          Flagship.notify("Info updated.");
        } else {
          Flagship.error(
            "Could not save user info.",
            this.props.routeParams.splat,
            this.props.userId
          );
        }
      }
    );
  }

  render() {
    if (typeof this.state.userData === "undefined") {
      return (
        <Table className="fade-in">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="5">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    } else {
      let title =
        parseInt(this.props.routeParams.splat) === this.props.userId ? (
          <h1 className="view-title">Edit Your Information</h1>
        ) : (
          <h1 className="view-title">Edit User: {this.props.username}</h1>
        );

      return (
        <div className="fade-in">
          {title}

          <Grid stackable>
            <Grid.Column
              mobile={16}
              tablet={16}
              computer={16}
              largeScreen={11}
              widescreen={12}
              width={16}
            >
              <Field
                type="text"
                name="fname"
                label="First Name"
                placeholder="First"
                value={this.state.userData.first_name}
                onChange={(e, value) => this.onChange(e, value, "first_name")}
              />

              <Field
                type="text"
                name="lname"
                label="Last Name"
                placeholder="Last"
                value={this.state.userData.last_name}
                onChange={(e, value) => this.onChange(e, value, "last_name")}
              />

              <Field
                type="text"
                name="email"
                label="Email Address"
                validation="email"
                placeholder="someone@2060digital.com"
                value={this.state.userData.email}
                onChange={(e, value) => this.onChange(e, value, "email")}
              />

              <Field
                type="text"
                name="phone"
                label="Phone"
                validation="phone"
                placeholder="e.g., 513-699-XXXX"
                value={this.state.userData.phone}
                onChange={(e, value) => this.onChange(e, value, "phone")}
              />
              <Divider />

              <Field
                type="password"
                validation="password"
                value={this.state.userData.password || ""}
                visible={this.state.passwordVisible}
                onChange={(e, value) => this.onChange(e, value, "password")}
              />

              <Divider />
              <Button onClick={this.saveUser} primary content="Save My Info" />
            </Grid.Column>
            <Grid.Column
              floated="right"
              textAlign="center"
              mobile={16}
              tablet={16}
              computer={16}
              largeScreen={5}
              widescreen={4}
              width={16}
            >
              <Field
                type="userPhoto"
                name="photo"
                label="Photo"
                value={this.state.userData.username + ".jpg"}
                default={this.state.userData.username + ".jpg"}
              />
            </Grid.Column>
          </Grid>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(SingleUserEdit);



// WEBPACK FOOTER //
// ./src/components/views/SingleUserEdit.js